class GoogleMapsLocation {
  constructor() { }
   SearchForLocation(search, callback) {
    if (typeof google !== 'object' && typeof google.maps !== 'object' && typeof google.maps.places !== 'object' && !google.maps.places.PlacesServiceStatus.OK) {
      console.log("google.maps.places not ready");
      return;
    }

    const service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions({ 
      input: search, 
      types: ["(regions)"],
      componentRestrictions: {country: 'au'} }, callback);
  }
}

export { GoogleMapsLocation }